// Variant Metafields Helper
// This module enriches variant objects with their metafields
// since Shopify's {{ product | json }} doesn't include variant metafields by default

(function () {
  let variantMetafieldsData = null;

  // Load and cache variant metafields from the JSON script tag
  function loadVariantMetafields() {
    if (variantMetafieldsData) {
      return variantMetafieldsData;
    }

    const metafieldsScript = document.querySelector(
      '[data-variant-metafields]'
    );
    if (!metafieldsScript) {
      console.warn('Variant metafields data not found');
      return {};
    }

    try {
      variantMetafieldsData = JSON.parse(metafieldsScript.textContent);
      return variantMetafieldsData;
    } catch (error) {
      console.error('Error parsing variant metafields:', error);
      return {};
    }
  }

  // Enrich a variant object with its metafields
  function enrichVariantWithMetafields(variant) {
    if (!variant || !variant.id) {
      return variant;
    }

    const metafieldsData = loadVariantMetafields();
    const variantMetafields = metafieldsData[variant.id];

    if (!variantMetafields) {
      return variant;
    }

    // Add metafields to variant object if not already present
    if (!variant.metafields) {
      variant.metafields = {};
    }
    if (!variant.metafields.custom) {
      variant.metafields.custom = {};
    }

    // Merge the metafields data
    Object.assign(variant.metafields.custom, variantMetafields);

    return variant;
  }

  // Intercept theme:variant:change events and enrich the variant
  document.addEventListener(
    'theme:variant:change',
    function (event) {
      if (event.detail && event.detail.variant) {
        enrichVariantWithMetafields(event.detail.variant);
      }
    },
    { capture: true } // Use capture phase to run before other listeners
  );

  // Export helper functions for direct use
  window.variantMetafieldsHelper = {
    enrichVariant: enrichVariantWithMetafields,
    getMetafields: loadVariantMetafields,
  };
})();